export const validateDateRange = (dateNow) => {
    // * OBTENER DIA ACTUAL
    const day = dateNow.getDate();
    
    return day >= 20 && day <= 30;
}
  